import * as z from "zod";
import { userFacingError } from "../authorization";
import { assertIdpSyncNotActive } from "../rbac/validation";
import { mutator } from "./mutator";

export const resendUserInviteSchema = z.object({
  userId: z.string(),
});

export const resendUserInvite = mutator({
  schema: resendUserInviteSchema,
  resolve: {
    target: { kind: "user", from: "userId" },
  },
  permissions: [
    { permission: "tenant:users_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { target } }) => {
    await assertIdpSyncNotActive(tx, ctx.tenantId, "userProvisioning");

    if (
      target.deactivated ||
      target.invitedAt == null ||
      target.lastActiveAt != null
    ) {
      throw userFacingError(
        "Only active invited members who have never signed in can be sent another invite"
      );
    }
  },
});
